export const governance_tabs = [
  { id: 'overview', label: 'Overview', count: null },
  { id: 'committees', label: 'Committees & ToR', count: 6 },
  { id: 'decisions', label: 'Decisions', count: 11 },
  { id: 'accountability', label: 'Accountability map', count: 8 },
  { id: 'calendar', label: 'Calendar', count: 6 },
  { id: 'consequences', label: 'Consequences', count: 5 }
];

export const summary_cards = [
  { title: 'Governance maturity', value: '3.6/5', note: 'Avg across 5 areas', tone: 'amber' },
  { title: 'Accountable areas', value: '8', note: '2 need attention', tone: 'orange', tab_id: 'accountability' },
  { title: 'Decisions pending', value: '2', note: 'Awaiting sign-off', tone: 'red', tab_id: 'decisions' },
  { title: 'Open consequence cases', value: '2', note: 'Breaches in progress', tone: 'red', tab_id: 'consequences' }
];

export const bridge_chips = [
  { label: 'Delegation of authority', route_name: 'DelegationOfAuthority', icon: 'bi-sign-turn-slight-right' },
  { label: 'Policies', route_name: 'CompliancePolicies', icon: 'bi-file-earmark-text' },
  { label: 'Controls library', route_name: 'ControlsLibrary', icon: 'bi-shield-check' },
  { label: 'Risks', route_name: 'RisksDashboard', icon: 'bi-exclamation-triangle' },
  { label: 'Audits', route_name: 'AuditsRegister', icon: 'bi-clipboard-check' },
  { label: 'Reports', route_name: 'ReportsDashboard', icon: 'bi-bar-chart' },
  { label: 'Incidents', route_name: 'IncidentsCases', icon: 'bi-bell' },
  { label: 'Conflicts of interest', route_name: 'ConflictsOfInterest', icon: 'bi-person-exclamation' },
  { label: 'Regulatory calendar', route_name: 'RegulatoryCalendar', icon: 'bi-calendar3' },
  { label: 'Evidence vault', route_name: 'EvidenceVault', icon: 'bi-folder2' }
];

export const framework_cards = [
  { title: 'Direct', icon: 'bi-diagram-3', copy: 'The board sets strategy, risk appetite and the delegation-of-authority framework that every decision must flow through.', icon_tone: 'teal' },
  { title: 'Control', icon: 'bi-shield-check', copy: 'Committees and controls turn that mandate into monitored, evidenced operation across every compliance domain.', icon_tone: 'teal' },
  { title: 'Account', icon: 'bi-people', copy: 'Every domain maps to a named accountable owner, with proof held in the evidence vault and reported up to the board.', icon_tone: 'teal' }
];

export const maturity_rows = [
  { label: 'Policies', value: 4, max: 5, status: 'Managed' },
  { label: 'Controls', value: 3, max: 5, status: 'Defined' },
  { label: 'Reporting', value: 4, max: 5, status: 'Managed' },
  { label: 'Evidence', value: 3, max: 5, status: 'Defined' },
  { label: 'Accountability', value: 4, max: 5, status: 'Managed' }
];

export const committee_type_options = ['Board', 'EXCO', 'Audit committee', 'Risk committee', 'Procurement committee', 'ICT steering committee'];
export const committee_cadence_options = ['Monthly', 'Bi-monthly', 'Quarterly', 'Bi-annual', 'Annual', 'Ad hoc'];
export const committee_status_options = ['Active', 'Forming', 'Dormant'];
export const decision_status_options = ['Passed', 'Awaiting signature', 'Deferred', 'Rejected'];
export const action_status_options = ['Open', 'In progress', 'Done', 'Overdue'];
export const accountability_status_options = ['On track', 'Attention', 'Gap'];
export const calendar_type_options = ['Board meeting', 'Committee meeting', 'Reporting deadline', 'Policy review'];
export const calendar_status_options = ['Scheduled', 'Due', 'Overdue', 'Done'];
export const consequence_severity_options = ['High', 'Medium', 'Low'];
export const consequence_status_options = ['Open', 'Under review', 'Action taken', 'Closed'];
